<!--
/**
 * DjBatchQueryTab.vue - 批量查询 Tab 组件
 *
 * 【功能说明】
 * 本组件是迪加(DJ)虚拟商品管理系统的批量查询页面，
 * 支持通过手动输入号码或上传文件的方式批量查询号码信息，
 * 查询结果可下载。同时展示历史批量查询记录。
 *
 * 【主要功能】
 * 1. 批量查询记录列表 - 展示历史批量查询的批次、数量、成功/失败数
 * 2. 手动输入查询 - 手动输入号码列表进行批量查询
 * 3. 文件上传查询 - 通过上传txt文件批量查询
 * 4. 模板下载 - 提供批量查询模板文件下载
 * 5. 结果下载 - 下载各批次的查询结果数据
 *
 * 【权限要求】
 * - 所有用户：可执行所有操作
 -->
<template>
  <div>
    <!-- ========== 操作按钮区域 ========== -->
    <div class="handle-box">
      <!-- 批量查询按钮 - 打开查询弹窗 -->
      <el-button size="small" type="primary" :class="[theme]"
                 @click="getbatchQueryRecord">批量查询
      </el-button>
      <!-- 下载模板链接 -->
      <a :href="`${path}dxtQuery.txt`" class="down" style="margin:10px 10px;" download="批量查询模板.txt"
         :class="[theme]">
        <i class="el-icon-download"></i>
        下载模板
      </a>
      <!-- 刷新按钮 -->
      <el-button size="small" type="primary" :class="[theme]" @click="batchQueryRecords">刷新</el-button>
    </div>

    <!-- ========== 批量查询记录表格 ========== -->
    <el-table :data="tableData2" border class="table" ref="multipleTable" max-height="600"
              header-cell-class-name="table-header" :row-style="{ height: '20px' }"
              :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
              v-loading="loading">
      <!-- 处理批次号 -->
      <el-table-column prop="uid" label="处理批次" align="center" width="350"></el-table-column>
      <!-- 总数量 -->
      <el-table-column prop="count" label="总数量" align="center"></el-table-column>
      <!-- 成功数量 -->
      <el-table-column prop="success" label="成功" align="center"></el-table-column>
      <!-- 失败数量（红色显示） -->
      <el-table-column prop="err" label="失败" align="center">
        <template #default="scope">
          <span style="color: #f56c6c;">{{ scope.row.err }}</span>
        </template>
      </el-table-column>
      <!-- 时间 -->
      <el-table-column prop="time" label="时间" align="center" width="160"></el-table-column>
      <!-- 操作者 -->
      <el-table-column prop="userPhone" label="操作者" align="center"></el-table-column>
      <!-- 操作列 - 下载查询结果 -->
      <el-table-column label="操作" width="240" align="center">
        <template #default="scope">
          <a :href="scope.row.url" class="down" download="迪迦用户信息批量查询数据.text" :class="[theme]">
            <i class="el-icon-download"></i>
            下载
          </a>
        </template>
      </el-table-column>
    </el-table>

    <!-- ========== 分页器 ========== -->
    <div class="pagination">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                     :current-page="query2.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                     :page-size="query2.pageSize" :total="pageTotal2" @size-change="handleSizeChange"
                     @current-change="handlePageChange"></el-pagination>
    </div>

    <!-- ========== 批量查询弹窗 ========== -->
    <el-dialog title="批量查询" v-model="addVisible1" width="520px" @close="closeDialog1">
      <el-form label-width="120px" :model="addForm1" ref="addForm1">
        <!-- 上传类型选择：手动输入 或 批量查询模板 -->
        <el-form-item label="上传类型" prop="type">
          <el-radio-group v-model="addForm1.type">
            <el-radio label="2">手动输入</el-radio>
            <el-radio label="1">批量查询模板</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 文件上传模式（type=='1'） -->
        <el-form-item label="上传文件" prop="type" v-if="addForm1.type=='1'">
          <el-upload ref="upload1" action="/api/dxt/batchQuery" :headers="token" :limit="1"
                     :on-success="uploadSuccess1" :auto-upload="false" :data="uploadData1">
            <el-button size="small" type="primary" :class="[theme]"
                       style="margin-top: 40px;">选择文件
            </el-button>
            <div class="el-upload__tip">只能导入txt文件</div>
          </el-upload>
        </el-form-item>
        <!-- 手动输入模式（type=='2'） -->
        <el-form-item label="批量查询" v-if="addForm1.type=='2'">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm1.phones" auto-complete="off"
                    placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog1">取消</el-button>
          <!-- 手动输入模式确定 -->
          <el-button size="small" type="primary" :class="[theme]" v-if="addForm1.type == '2'"
                     @click="getbatchQuery">确定
          </el-button>
          <!-- 文件上传模式确定 -->
          <el-button v-else size="small" type="primary" :class="[theme]" @click="submitUpload1">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 批量查询 Tab 组件脚本部分
 *
 * 引入的 API 接口：
 * - batchQueryRecord：查询批量查询记录列表
 * - dxtbatchQuery：执行批量查询（手动输入模式）
 */
import {
  batchQueryRecord,
  dxtbatchQuery
} from '../../../api/dijia.js';

export default {
  name: 'DjBatchQueryTab',

  /**
   * 【Props 接收的参数】
   * - theme：主题颜色样式类名
   * - path：静态资源路径（用于下载模板文件）
   * - token：请求头信息，用于文件上传鉴权
   */
  props: {
    theme: { type: String, default: '' },
    path: { type: String, default: '' },
    token: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      // ========== 查询相关 ==========
      loading: false,           // 表格加载状态
      query2: {                 // 查询参数
        pageIndex: 1,           // 当前页码
        pageSize: 10,           // 每页条数
        userId: localStorage.getItem('user'),
      },
      tableData2: [],           // 批量查询记录列表
      pageTotal2: 0,            // 总条数

      // ========== 批量查询弹窗相关 ==========
      addVisible1: false,       // 弹窗是否显示
      addForm1: {               // 查询表单
        userId: localStorage.getItem('user'),
        phones: '',             // 号码（一行一个）
        type: '2',              // 类型（1=文件上传，2=手动输入）
      },
      uploadData1: {            // 文件上传附加数据
        userId: localStorage.getItem('user'),
      },
    };
  },

  /**
   * 组件创建时查询批量查询记录列表
   */
  created() {
    this.batchQueryRecords();
  },

  methods: {
    /**
     * batchQueryRecords - 查询批量查询记录列表
     */
    batchQueryRecords() {
      this.loading = true;
      batchQueryRecord(this.query2).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData2 = res.data.list;
          this.pageTotal2 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * getbatchQueryRecord - 打开批量查询弹窗
     */
    getbatchQueryRecord() {
      this.addVisible1 = true;
      this.addForm1.phones = '';
      this.addForm1.type = '2';
    },

    /**
     * getbatchQuery - 手动输入模式提交批量查询
     */
    getbatchQuery() {
      dxtbatchQuery(this.addForm1).then(res => {
        if (res?.code === 200) {
          this.$message.success(res.data);
          this.addVisible1 = false;
          this.batchQueryRecords();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * submitUpload1 - 文件上传模式提交
     */
    submitUpload1() {
      if (this.$refs.upload1.uploadFiles[0]) {
        this.loading = true;
        this.$refs.upload1.submit();
        this.batchQueryRecords();
      } else {
        this.$message.error('请选择上传文件');
      }
    },

    /**
     * uploadSuccess1 - 文件上传成功回调
     * @param {Object} success - 上传接口返回结果
     */
    uploadSuccess1(success) {
      setTimeout(() => {
        this.$refs.upload1.clearFiles();
        this.addVisible1 = false;
      }, 2000);
      if (success?.code === 200) {
        this.$message.success('上传成功');
        this.batchQueryRecords();
      } else {
        this.$message.error(success.message);
      }
    },

    /**
     * closeDialog1 - 关闭弹窗
     */
    closeDialog1() {
      this.addVisible1 = false;
    },

    /**
     * handlePageChange - 翻页回调
     * @param {number} val - 新的页码
     */
    handlePageChange(val) {
      this.query2.pageIndex = val;
      this.batchQueryRecords();
    },

    /**
     * handleSizeChange - 每页条数变化回调
     * @param {number} val - 新的每页条数
     */
    handleSizeChange(val) {
      this.query2.pageSize = val;
      this.query2.pageIndex = 1;
      this.batchQueryRecords();
    },
  }
};
</script>

<style scoped>
@import './tab-styles.css';
</style>
